@use "@fukuri-admins/ui/layout" as *;

.headCell {
  padding: spacing('8') spacing('12');
  border-bottom: 1px solid border('Tertiary');
  white-space: nowrap;
  vertical-align: middle;
}

.alignLeft {
  text-align: left;
}

.alignRight {
  text-align: right;
}

.sortableButton {
  display: inline-flex;
  align-items: center;
  gap: spacing('4');
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
}

.sortIcon {
  flex-shrink: 0;
  color: text('Low');
}
